const sysKeywords = {
  doc_question: "question"
}

export default sysKeywords